/* eslint-disable max-classes-per-file */

import { ObjectUtils } from "~app/common/utils/object-utils";
import { VKAvverkningskostnadAtgardDTO } from "../../dto/avverkningskostnader/avverkningskostnader-dto";
import * as Request from "../../dto/vardeberakning/vardeberakning-request-dto";

export class AvverkningskostnadAtgard {
    virkeskopsatgardId: number;
    virkeskopsatgardGuid: string;
    mattslag: string;
    avverkningskostnader: Avverkningskostnad[];

    constructor(dto?: VKAvverkningskostnadAtgardDTO) {
        if (ObjectUtils.hasValue(dto)) {
            this.avverkningskostnader = dto.avverkningskostnader.map(x =>
                new Avverkningskostnad(x.typ, x.kostnadMattslag, x.kostnadTotal, x.kostnadBeraknadTotal, x.id));
            this.virkeskopsatgardId = dto.virkeskopsatgardId;
            this.virkeskopsatgardGuid = dto.virkeskopsatgardGUID;
            this.mattslag = dto.mattslag;
            this.virkeskopsatgardGuid = dto.virkeskopsatgardGUID;
        }
    }

    mapToDto(): Request.AvverkningskostnadDTO[] {
        return this.avverkningskostnader.map(x =>
            ({
                typ: x.typ,
                mattslag: this.mattslag,
                krPerMattslag: x.kostnadBeraknadTotal ? x.kostnadMattslag : null,
                krTotalt: x.kostnadBeraknadTotal ? null : x.kostnadTotal
            }));
    }
}

export class Avverkningskostnad {
    id?: number;
    typ: string;
    kostnadMattslag?: number;
    kostnadTotal?: number;
    kostnadBeraknadTotal: boolean;

    constructor(typ: string, kostnadMattslag?: number, kostnadTotal?: number, kostnadBeraknadTotal?: boolean, id?: number) {
        this.id = id;
        this.typ = typ;
        this.kostnadMattslag = kostnadMattslag;
        this.kostnadTotal = kostnadTotal;
        this.kostnadBeraknadTotal = kostnadBeraknadTotal;
    }
}

export class AvverkningskostnadViewmodel {
    krPerMattslag?: number;
    total?: number;
    konverteringsfaktor?: number;

    get krPerM3Fub(): number {
        return Math.round(this.krPerMattslag * this.konverteringsfaktor);
    }

    get krPerM3FubPresentation(): string {
        return Math.round(this.krPerMattslag * this.konverteringsfaktor).toLocaleString();
    }
    get kostnadBeraknadTotal(): boolean {
        return this.internal.kostnadBeraknadTotal;
    }
    set kostnadBeraknadTotal(val: boolean) {
        this.internal.kostnadBeraknadTotal = val;
    }
    get avverkningskostnad(): Avverkningskostnad {
        return {
            id: this.internal.id,
            kostnadBeraknadTotal: this.kostnadBeraknadTotal,
            typ: this.internal.typ,
            kostnadMattslag: this.krPerMattslag,
            kostnadTotal: this.total
        };
    }
    get typ(): string {
        return this.internal.typ;
    }

    private readonly internal: Avverkningskostnad;

    constructor(avverkningskostnad: Avverkningskostnad, konverteringsfaktor?: number) {
        this.internal = avverkningskostnad;
        this.krPerMattslag = avverkningskostnad.kostnadMattslag ?? 0;
        this.total = avverkningskostnad.kostnadTotal ?? 0;
        this.konverteringsfaktor = konverteringsfaktor;
    }
}

export class AvverkningskostnaderEvent {
    avverkningskostnader: AvverkningskostnadAtgard[];
    source: any;

    constructor(avverkningskostnader: AvverkningskostnadAtgard[], source?: any) {
        this.avverkningskostnader = avverkningskostnader;
        this.source = source;
    }

    getForAtgard(atgardGUID: string): AvverkningskostnadAtgard {
        return this.avverkningskostnader?.find(x => x.virkeskopsatgardGuid === atgardGUID);
    }
}
